
import React from 'react';

const SubmissionHistoryViewer = ({ history, currentId, onSelect, isLoading }) => {
  // Don't render if there's only one or zero submissions in the history.
  if (!history || history.length <= 1) {
    return null;
  }

  return (
    <div className="mb-3 card bg-light" style={{ maxWidth: '1000px', left: '57%', transform: 'translateX(-50%)' }}>
      <div className="card-body d-flex align-items-center flex-wrap">
        <label htmlFor="version-selector" className="form-label mb-0 me-3 fw-bold">
          View Submission History:
        </label>
        <select
          id="version-selector"
          className="form-select w-auto"
          value={currentId || ''}
          onChange={(e) => onSelect(e.target.value)}
          disabled={isLoading}
        >
          {history.map((item, index) => (
            <option key={item._id} value={item._id}>
              Version {item.version} -{' '}
              
              {new Date(item.submittedAt).toLocaleString()} (by {item.submittedBy?.name ?? 'Deleted User'})
              {index === 0 && ' (Latest)'}
            </option>
          ))}
        </select>
        {currentId !== history[0]?._id && (
          <span className="badge bg-warning text-dark ms-3 mt-2 mt-md-0">Viewing a previous version (Read-Only)</span>
        )}
      </div>
    </div>
  );
};

export default SubmissionHistoryViewer;